import React from 'react';
import { Button, Space, Typography, message } from 'antd';
import { Link } from 'react-router-dom';
import { EyeOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { documentService } from '@/services/document.service';

const UUID_LIKE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface MtcDocumentLinkProps {
  documentId?: string | null;
  documentNumber?: string | null;
  /** Tighter spacing for table cells */
  compact?: boolean;
}

/**
 * Shows MTC / certificate document number (not raw UUID) with actions to view the file or open the library.
 */
export const MtcDocumentLink: React.FC<MtcDocumentLinkProps> = ({
  documentId,
  documentNumber,
  compact,
}) => {
  const id = documentId != null ? String(documentId).trim() : '';
  if (!id) {
    return <span>—</span>;
  }

  const num = documentNumber != null ? String(documentNumber).trim() : '';
  const label = num || (UUID_LIKE.test(id) ? 'MTC document' : id);

  const libraryTo = `/platform/documents?doc=${encodeURIComponent(id)}`;

  const onView = async () => {
    try {
      await documentService.openDocumentInNewTab(id);
    } catch {
      message.error('Could not open document');
    }
  };

  return (
    <Space size={compact ? 4 : 8} wrap align="center">
      <Typography.Text strong={!!num} style={{ fontSize: compact ? 13 : undefined }}>
        {label}
      </Typography.Text>
      <Button type="link" size="small" icon={<EyeOutlined />} onClick={onView} style={{ padding: 0 }}>
        View
      </Button>
      <Link to={libraryTo} style={{ fontSize: compact ? 12 : 13 }}>
        <FolderOpenOutlined /> Library
      </Link>
    </Space>
  );
};
